import {
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import IconBox from "components/icons/IconBox";
import { IconArrowDown } from "components/icons/Icons";
import { getTranslatorsByLanguage } from "../helpers/documentHelpers";

interface TranslatorCellProps {
  translators: any[];
  allTranslators: any[];
  sourceLanguage: string;
  targetLanguage: string;
  onAssignTranslator: (documentId: string, translator: any) => void;
  onClickView: (translator: any) => void;
  documentId: string;
}

export function TranslatorCell({
  translators,
  allTranslators,
  sourceLanguage,
  targetLanguage,
  onAssignTranslator,
  onClickView,
  documentId,
}: TranslatorCellProps) {
  const shadow = useColorModeValue(
    "0px 4px 50px rgba(0, 0, 0, 0.1)",
    "0px 4px 50px rgba(0, 0, 0, 0.1)"
  );

  const translatorSearch = getTranslatorsByLanguage(
    allTranslators,
    sourceLanguage,
    targetLanguage
  );

  const displayTranslators = translatorSearch.length > 0 ? translatorSearch : allTranslators;

  return (
    <Flex alignItems="center">
      <Menu closeOnSelect={true}>
        <MenuButton
          padding={"10px 10px 10px 15px"}
          backgroundColor="#FFF"
          borderRadius="100px"
          border="1px solid #E9E9E9"
        >
          <Flex alignItems={"center"}>
            <Text
              fontSize={"14px"}
              lineHeight="24px"
              fontWeight={"400"}
              color="black"
              maxW={{ md: "100px", base: "100%" }}
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              {translators?.length > 0
                ? `${translators[0]?.first_name} ${translators[0]?.last_name}`
                : "Not Assigned"}
            </Text>
            <IconBox
              marginLeft="10px"
              icon={<IconArrowDown width="24px" height="24px" />}
            />
          </Flex>
        </MenuButton>
        <MenuList
          width="195px"
          minWidth="195px"
          maxH="300px"
          overflow="auto"
          boxShadow={shadow}
          p="0px"
          mt="10px"
          borderRadius="20px"
          bg={"#FFF"}
          border="none"
        >
          <Flex
            flexDirection="column"
            p="10px 20px"
            fontSize={"14px"}
            lineHeight="24px"
            fontWeight={"400"}
            color="black"
          >
            {displayTranslators.map((option: any, index: number) => {
              const isAssigned = translators
                .map(({ email }) => email)
                .includes(option.email);

              return (
                <MenuItem
                  key={index}
                  _hover={{ bg: "none" }}
                  _focus={{ bg: "none" }}
                  borderRadius="8px"
                  padding="10px 0px"
                  borderBottom={
                    index < displayTranslators.length - 1
                      ? "1px solid #F3F5F5"
                      : ""
                  }
                  onClick={() => onAssignTranslator(documentId, option)}
                >
                  <Text
                    fontSize="sm"
                    className={isAssigned ? "blue-text" : "default-text"}
                  >
                    {`${option?.first_name ?? ""} ${option?.last_name ?? ""}`}
                  </Text>
                  <Button
                    padding="5px 10px"
                    borderRadius="100px"
                    bgColor="#F3F5F5"
                    fontSize={"14px"}
                    lineHeight="24px"
                    fontWeight={"400"}
                    marginLeft="auto"
                    onClick={(e) => {
                      onClickView(option);
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                  >
                    View
                  </Button>
                </MenuItem>
              );
            })}
          </Flex>
        </MenuList>
      </Menu>
    </Flex>
  );
}
